export function trackOutboundLink(e, href) {
  e.preventDefault();
   window.ga('send', 'event', 'outbound', 'click', href, {
     'transport': 'beacon',
     'hitCallback': function(){window.open(href, '_blank')}
   });
}



/** WEBPACK FOOTER **
 ** ./src/google-analytics.js
 **/